module.exports = __webpack_public_path__ + "static/hlidac.11f3809f.jpg";